!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.MusculaLog = n() : e.MusculaLog = n();
}(self, function () {
  return e = {
    180: function _(e, n, t) {
      var r, o, i;
      !function (a, s) {
        "use strict";

        o = [t(829)], void 0 === (i = "function" == typeof (r = function r(e) {
          var n = /(^|@)\S+:\d+/,
              t = /^\s*at .*(\S+:\d+|\(native\))/m,
              r = /^(eval@)?(\[native code])?$/;
          return {
            parse: function parse(e) {
              if (void 0 !== e.stacktrace || void 0 !== e["opera#sourceloc"]) return this.parseOpera(e);
              if (e.stack && e.stack.match(t)) return this.parseV8OrIE(e);
              if (e.stack) return this.parseFFOrSafari(e);
              throw new Error("Cannot parse given Error object");
            },
            extractLocation: function extractLocation(e) {
              if (-1 === e.indexOf(":")) return [e];
              var n = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e.replace(/[()]/g, ""));
              return [n[1], n[2] || void 0, n[3] || void 0];
            },
            parseV8OrIE: function parseV8OrIE(n) {
              return n.stack.split("\n").filter(function (e) {
                return !!e.match(t);
              }, this).map(function (n) {
                n.indexOf("(eval ") > -1 && (n = n.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                var t = n.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""),
                    r = t.match(/ (\(.+\)$)/);
                t = r ? t.replace(r[0], "") : t;
                var o = this.extractLocation(r ? r[1] : t),
                    i = r && t || void 0,
                    a = ["eval", "<anonymous>"].indexOf(o[0]) > -1 ? void 0 : o[0];
                return new e({
                  functionName: i,
                  fileName: a,
                  lineNumber: o[1],
                  columnNumber: o[2],
                  source: n
                });
              }, this);
            },
            parseFFOrSafari: function parseFFOrSafari(n) {
              return n.stack.split("\n").filter(function (e) {
                return !e.match(r);
              }, this).map(function (n) {
                if (n.indexOf(" > eval") > -1 && (n = n.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === n.indexOf("@") && -1 === n.indexOf(":")) return new e({
                  functionName: n
                });
                var t = /((.*".+"[^@]*)?[^@]*)(?:@)/,
                    r = n.match(t),
                    o = r && r[1] ? r[1] : void 0,
                    i = this.extractLocation(n.replace(t, ""));
                return new e({
                  functionName: o,
                  fileName: i[0],
                  lineNumber: i[1],
                  columnNumber: i[2],
                  source: n
                });
              }, this);
            },
            parseOpera: function parseOpera(e) {
              return !e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length ? this.parseOpera9(e) : e.stack ? this.parseOpera11(e) : this.parseOpera10(e);
            },
            parseOpera9: function parseOpera9(n) {
              for (var t = /Line (\d+).*script (?:in )?(\S+)/i, r = n.message.split("\n"), o = [], i = 2, a = r.length; i < a; i += 2) {
                var s = t.exec(r[i]);
                s && o.push(new e({
                  fileName: s[2],
                  lineNumber: s[1],
                  source: r[i]
                }));
              }

              return o;
            },
            parseOpera10: function parseOpera10(n) {
              for (var t = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = n.stacktrace.split("\n"), o = [], i = 0, a = r.length; i < a; i += 2) {
                var s = t.exec(r[i]);
                s && o.push(new e({
                  functionName: s[3] || void 0,
                  fileName: s[2],
                  lineNumber: s[1],
                  source: r[i]
                }));
              }

              return o;
            },
            parseOpera11: function parseOpera11(t) {
              return t.stack.split("\n").filter(function (e) {
                return !!e.match(n) && !e.match(/^Error created at/);
              }, this).map(function (n) {
                var t,
                    r = n.split("@"),
                    o = this.extractLocation(r.pop()),
                    i = r.shift() || "",
                    a = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                i.match(/\(([^)]*)\)/) && (t = i.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                var s = void 0 === t || "[arguments not available]" === t ? void 0 : t.split(",");
                return new e({
                  functionName: a,
                  args: s,
                  fileName: o[0],
                  lineNumber: o[1],
                  columnNumber: o[2],
                  source: n
                });
              }, this);
            }
          };
        }) ? r.apply(n, o) : r) || (e.exports = i);
      }();
    },
    595: function _(e, n, t) {
      var r, o, i;
      !function (a, s) {
        "use strict";

        o = [t(829)], r = function r(e) {
          return {
            backtrace: function backtrace(n) {
              var t = [],
                  r = 10;
              "object" == typeof n && "number" == typeof n.maxStackSize && (r = n.maxStackSize);

              for (var o = arguments.callee; o && t.length < r && o.arguments;) {
                for (var i = new Array(o.arguments.length), a = 0; a < i.length; ++a) {
                  i[a] = o.arguments[a];
                }

                /function(?:\s+([\w$]+))+\s*\(/.test(o.toString()) ? t.push(new e({
                  functionName: RegExp.$1 || void 0,
                  args: i
                })) : t.push(new e({
                  args: i
                }));

                try {
                  o = o.caller;
                } catch (e) {
                  break;
                }
              }

              return t;
            }
          };
        }, void 0 === (i = r.apply(n, o)) || (e.exports = i);
      }();
    },
    829: function _(e, n) {
      var t, r, o;
      !function (i, a) {
        "use strict";

        r = [], void 0 === (o = "function" == typeof (t = function t() {
          function e(e) {
            return e.charAt(0).toUpperCase() + e.substring(1);
          }

          function n(e) {
            return function () {
              return this[e];
            };
          }

          var t = ["isConstructor", "isEval", "isNative", "isToplevel"],
              r = ["columnNumber", "lineNumber"],
              o = ["fileName", "functionName", "source"],
              i = t.concat(r, o, ["args"], ["evalOrigin"]);

          function a(n) {
            if (n) for (var t = 0; t < i.length; t++) {
              void 0 !== n[i[t]] && this["set" + e(i[t])](n[i[t]]);
            }
          }

          a.prototype = {
            getArgs: function getArgs() {
              return this.args;
            },
            setArgs: function setArgs(e) {
              if ("[object Array]" !== Object.prototype.toString.call(e)) throw new TypeError("Args must be an Array");
              this.args = e;
            },
            getEvalOrigin: function getEvalOrigin() {
              return this.evalOrigin;
            },
            setEvalOrigin: function setEvalOrigin(e) {
              if (e instanceof a) this.evalOrigin = e;else {
                if (!(e instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                this.evalOrigin = new a(e);
              }
            },
            toString: function toString() {
              var e = this.getFileName() || "",
                  n = this.getLineNumber() || "",
                  t = this.getColumnNumber() || "",
                  r = this.getFunctionName() || "";
              return this.getIsEval() ? e ? "[eval] (" + e + ":" + n + ":" + t + ")" : "[eval]:" + n + ":" + t : r ? r + " (" + e + ":" + n + ":" + t + ")" : e + ":" + n + ":" + t;
            }
          }, a.fromString = function (e) {
            var n = e.indexOf("("),
                t = e.lastIndexOf(")"),
                r = e.substring(0, n),
                o = e.substring(n + 1, t).split(","),
                i = e.substring(t + 1);
            if (0 === i.indexOf("@")) var s = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ""),
                u = s[1],
                c = s[2],
                l = s[3];
            return new a({
              functionName: r,
              args: o || void 0,
              fileName: u,
              lineNumber: c || void 0,
              columnNumber: l || void 0
            });
          };

          for (var s = 0; s < t.length; s++) {
            a.prototype["get" + e(t[s])] = n(t[s]), a.prototype["set" + e(t[s])] = function (e) {
              return function (n) {
                this[e] = Boolean(n);
              };
            }(t[s]);
          }

          for (var u = 0; u < r.length; u++) {
            a.prototype["get" + e(r[u])] = n(r[u]), a.prototype["set" + e(r[u])] = function (e) {
              return function (n) {
                if (t = n, isNaN(parseFloat(t)) || !isFinite(t)) throw new TypeError(e + " must be a Number");
                var t;
                this[e] = Number(n);
              };
            }(r[u]);
          }

          for (var c = 0; c < o.length; c++) {
            a.prototype["get" + e(o[c])] = n(o[c]), a.prototype["set" + e(o[c])] = function (e) {
              return function (n) {
                this[e] = String(n);
              };
            }(o[c]);
          }

          return a;
        }) ? t.apply(n, r) : t) || (e.exports = o);
      }();
    },
    817: function _(e, n, t) {
      var r = t(479),
          o = Object.prototype.hasOwnProperty;

      function i() {
        this._array = [], this._set = Object.create(null);
      }

      i.fromArray = function (e, n) {
        for (var t = new i(), r = 0, o = e.length; r < o; r++) {
          t.add(e[r], n);
        }

        return t;
      }, i.prototype.size = function () {
        return Object.getOwnPropertyNames(this._set).length;
      }, i.prototype.add = function (e, n) {
        var t = r.toSetString(e),
            i = o.call(this._set, t),
            a = this._array.length;
        i && !n || this._array.push(e), i || (this._set[t] = a);
      }, i.prototype.has = function (e) {
        var n = r.toSetString(e);
        return o.call(this._set, n);
      }, i.prototype.indexOf = function (e) {
        var n = r.toSetString(e);
        if (o.call(this._set, n)) return this._set[n];
        throw new Error('"' + e + '" is not in the set.');
      }, i.prototype.at = function (e) {
        if (e >= 0 && e < this._array.length) return this._array[e];
        throw new Error("No element indexed by " + e);
      }, i.prototype.toArray = function () {
        return this._array.slice();
      }, n.I = i;
    },
    647: function _(e, n, t) {
      var r = t(855);
      n.encode = function (e) {
        var n,
            t = "",
            o = function (e) {
          return e < 0 ? 1 + (-e << 1) : 0 + (e << 1);
        }(e);

        do {
          n = 31 & o, (o >>>= 5) > 0 && (n |= 32), t += r.encode(n);
        } while (o > 0);

        return t;
      }, n.decode = function (e, n, t) {
        var o,
            i,
            a,
            s,
            u = e.length,
            c = 0,
            l = 0;

        do {
          if (n >= u) throw new Error("Expected more digits in base 64 VLQ value.");
          if (-1 === (i = r.decode(e.charCodeAt(n++)))) throw new Error("Invalid base64 digit: " + e.charAt(n - 1));
          o = !!(32 & i), c += (i &= 31) << l, l += 5;
        } while (o);

        t.value = (s = (a = c) >> 1, 1 == (1 & a) ? -s : s), t.rest = n;
      };
    },
    855: function _(e, n) {
      var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
      n.encode = function (e) {
        if (0 <= e && e < t.length) return t[e];
        throw new TypeError("Must be between 0 and 63: " + e);
      }, n.decode = function (e) {
        return 65 <= e && e <= 90 ? e - 65 : 97 <= e && e <= 122 ? e - 97 + 26 : 48 <= e && e <= 57 ? e - 48 + 52 : 43 == e ? 62 : 47 == e ? 63 : -1;
      };
    },
    274: function _(e, n) {
      function t(e, r, o, i, a, s) {
        var u = Math.floor((r - e) / 2) + e,
            c = a(o, i[u], !0);
        return 0 === c ? u : c > 0 ? r - u > 1 ? t(u, r, o, i, a, s) : s == n.LEAST_UPPER_BOUND ? r < i.length ? r : -1 : u : u - e > 1 ? t(e, u, o, i, a, s) : s == n.LEAST_UPPER_BOUND ? u : e < 0 ? -1 : e;
      }

      n.GREATEST_LOWER_BOUND = 1, n.LEAST_UPPER_BOUND = 2, n.search = function (e, r, o, i) {
        if (0 === r.length) return -1;
        var a = t(-1, r.length, e, r, o, i || n.GREATEST_LOWER_BOUND);
        if (a < 0) return -1;

        for (; a - 1 >= 0 && 0 === o(r[a], r[a - 1], !0);) {
          --a;
        }

        return a;
      };
    },
    27: function _(e, n, t) {
      var r = t(479);

      function o() {
        this._array = [], this._sorted = !0, this._last = {
          generatedLine: -1,
          generatedColumn: 0
        };
      }

      o.prototype.unsortedForEach = function (e, n) {
        this._array.forEach(e, n);
      }, o.prototype.add = function (e) {
        var n, t, o, i, a, s;
        t = e, o = (n = this._last).generatedLine, i = t.generatedLine, a = n.generatedColumn, s = t.generatedColumn, i > o || i == o && s >= a || r.compareByGeneratedPositionsInflated(n, t) <= 0 ? (this._last = e, this._array.push(e)) : (this._sorted = !1, this._array.push(e));
      }, o.prototype.toArray = function () {
        return this._sorted || (this._array.sort(r.compareByGeneratedPositionsInflated), this._sorted = !0), this._array;
      }, n.H = o;
    },
    956: function _(e, n) {
      function t(e, n, t) {
        var r = e[n];
        e[n] = e[t], e[t] = r;
      }

      function r(e, n, o, i) {
        if (o < i) {
          var a = o - 1;
          t(e, (l = o, f = i, Math.round(l + Math.random() * (f - l))), i);

          for (var s = e[i], u = o; u < i; u++) {
            n(e[u], s) <= 0 && t(e, a += 1, u);
          }

          t(e, a + 1, u);
          var c = a + 1;
          r(e, n, o, c - 1), r(e, n, c + 1, i);
        }

        var l, f;
      }

      n.U = function (e, n) {
        r(e, n, 0, e.length - 1);
      };
    },
    667: function _(e, n, t) {
      var r = t(479),
          o = t(274),
          i = t(817).I,
          a = t(647),
          s = t(956).U;

      function u(e) {
        var n = e;
        return "string" == typeof e && (n = JSON.parse(e.replace(/^\)\]\}'/, ""))), null != n.sections ? new f(n) : new c(n);
      }

      function c(e) {
        var n = e;
        "string" == typeof e && (n = JSON.parse(e.replace(/^\)\]\}'/, "")));
        var t = r.getArg(n, "version"),
            o = r.getArg(n, "sources"),
            a = r.getArg(n, "names", []),
            s = r.getArg(n, "sourceRoot", null),
            u = r.getArg(n, "sourcesContent", null),
            c = r.getArg(n, "mappings"),
            l = r.getArg(n, "file", null);
        if (t != this._version) throw new Error("Unsupported version: " + t);
        o = o.map(String).map(r.normalize).map(function (e) {
          return s && r.isAbsolute(s) && r.isAbsolute(e) ? r.relative(s, e) : e;
        }), this._names = i.fromArray(a.map(String), !0), this._sources = i.fromArray(o, !0), this.sourceRoot = s, this.sourcesContent = u, this._mappings = c, this.file = l;
      }

      function l() {
        this.generatedLine = 0, this.generatedColumn = 0, this.source = null, this.originalLine = null, this.originalColumn = null, this.name = null;
      }

      function f(e) {
        var n = e;
        "string" == typeof e && (n = JSON.parse(e.replace(/^\)\]\}'/, "")));
        var t = r.getArg(n, "version"),
            o = r.getArg(n, "sections");
        if (t != this._version) throw new Error("Unsupported version: " + t);
        this._sources = new i(), this._names = new i();
        var a = {
          line: -1,
          column: 0
        };
        this._sections = o.map(function (e) {
          if (e.url) throw new Error("Support for url field in sections not implemented.");
          var n = r.getArg(e, "offset"),
              t = r.getArg(n, "line"),
              o = r.getArg(n, "column");
          if (t < a.line || t === a.line && o < a.column) throw new Error("Section offsets must be ordered and non-overlapping.");
          return a = n, {
            generatedOffset: {
              generatedLine: t + 1,
              generatedColumn: o + 1
            },
            consumer: new u(r.getArg(e, "map"))
          };
        });
      }

      u.fromSourceMap = function (e) {
        return c.fromSourceMap(e);
      }, u.prototype._version = 3, u.prototype.__generatedMappings = null, Object.defineProperty(u.prototype, "_generatedMappings", {
        get: function get() {
          return this.__generatedMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__generatedMappings;
        }
      }), u.prototype.__originalMappings = null, Object.defineProperty(u.prototype, "_originalMappings", {
        get: function get() {
          return this.__originalMappings || this._parseMappings(this._mappings, this.sourceRoot), this.__originalMappings;
        }
      }), u.prototype._charIsMappingSeparator = function (e, n) {
        var t = e.charAt(n);
        return ";" === t || "," === t;
      }, u.prototype._parseMappings = function (e, n) {
        throw new Error("Subclasses must implement _parseMappings");
      }, u.GENERATED_ORDER = 1, u.ORIGINAL_ORDER = 2, u.GREATEST_LOWER_BOUND = 1, u.LEAST_UPPER_BOUND = 2, u.prototype.eachMapping = function (e, n, t) {
        var o,
            i = n || null;

        switch (t || u.GENERATED_ORDER) {
          case u.GENERATED_ORDER:
            o = this._generatedMappings;
            break;

          case u.ORIGINAL_ORDER:
            o = this._originalMappings;
            break;

          default:
            throw new Error("Unknown order of iteration.");
        }

        var a = this.sourceRoot;
        o.map(function (e) {
          var n = null === e.source ? null : this._sources.at(e.source);
          return null != n && null != a && (n = r.join(a, n)), {
            source: n,
            generatedLine: e.generatedLine,
            generatedColumn: e.generatedColumn,
            originalLine: e.originalLine,
            originalColumn: e.originalColumn,
            name: null === e.name ? null : this._names.at(e.name)
          };
        }, this).forEach(e, i);
      }, u.prototype.allGeneratedPositionsFor = function (e) {
        var n = r.getArg(e, "line"),
            t = {
          source: r.getArg(e, "source"),
          originalLine: n,
          originalColumn: r.getArg(e, "column", 0)
        };
        if (null != this.sourceRoot && (t.source = r.relative(this.sourceRoot, t.source)), !this._sources.has(t.source)) return [];
        t.source = this._sources.indexOf(t.source);

        var i = [],
            a = this._findMapping(t, this._originalMappings, "originalLine", "originalColumn", r.compareByOriginalPositions, o.LEAST_UPPER_BOUND);

        if (a >= 0) {
          var s = this._originalMappings[a];
          if (void 0 === e.column) for (var u = s.originalLine; s && s.originalLine === u;) {
            i.push({
              line: r.getArg(s, "generatedLine", null),
              column: r.getArg(s, "generatedColumn", null),
              lastColumn: r.getArg(s, "lastGeneratedColumn", null)
            }), s = this._originalMappings[++a];
          } else for (var c = s.originalColumn; s && s.originalLine === n && s.originalColumn == c;) {
            i.push({
              line: r.getArg(s, "generatedLine", null),
              column: r.getArg(s, "generatedColumn", null),
              lastColumn: r.getArg(s, "lastGeneratedColumn", null)
            }), s = this._originalMappings[++a];
          }
        }

        return i;
      }, n.SourceMapConsumer = u, c.prototype = Object.create(u.prototype), c.prototype.consumer = u, c.fromSourceMap = function (e) {
        var n = Object.create(c.prototype),
            t = n._names = i.fromArray(e._names.toArray(), !0),
            o = n._sources = i.fromArray(e._sources.toArray(), !0);
        n.sourceRoot = e._sourceRoot, n.sourcesContent = e._generateSourcesContent(n._sources.toArray(), n.sourceRoot), n.file = e._file;

        for (var a = e._mappings.toArray().slice(), u = n.__generatedMappings = [], f = n.__originalMappings = [], p = 0, h = a.length; p < h; p++) {
          var g = a[p],
              d = new l();
          d.generatedLine = g.generatedLine, d.generatedColumn = g.generatedColumn, g.source && (d.source = o.indexOf(g.source), d.originalLine = g.originalLine, d.originalColumn = g.originalColumn, g.name && (d.name = t.indexOf(g.name)), f.push(d)), u.push(d);
        }

        return s(n.__originalMappings, r.compareByOriginalPositions), n;
      }, c.prototype._version = 3, Object.defineProperty(c.prototype, "sources", {
        get: function get() {
          return this._sources.toArray().map(function (e) {
            return null != this.sourceRoot ? r.join(this.sourceRoot, e) : e;
          }, this);
        }
      }), c.prototype._parseMappings = function (e, n) {
        for (var t, o, i, u, c, f = 1, p = 0, h = 0, g = 0, d = 0, m = 0, v = e.length, _ = 0, y = {}, w = {}, C = [], b = []; _ < v;) {
          if (";" === e.charAt(_)) f++, _++, p = 0;else if ("," === e.charAt(_)) _++;else {
            for ((t = new l()).generatedLine = f, u = _; u < v && !this._charIsMappingSeparator(e, u); u++) {
              ;
            }

            if (i = y[o = e.slice(_, u)]) _ += o.length;else {
              for (i = []; _ < u;) {
                a.decode(e, _, w), c = w.value, _ = w.rest, i.push(c);
              }

              if (2 === i.length) throw new Error("Found a source, but no line and column");
              if (3 === i.length) throw new Error("Found a source and line, but no column");
              y[o] = i;
            }
            t.generatedColumn = p + i[0], p = t.generatedColumn, i.length > 1 && (t.source = d + i[1], d += i[1], t.originalLine = h + i[2], h = t.originalLine, t.originalLine += 1, t.originalColumn = g + i[3], g = t.originalColumn, i.length > 4 && (t.name = m + i[4], m += i[4])), b.push(t), "number" == typeof t.originalLine && C.push(t);
          }
        }

        s(b, r.compareByGeneratedPositionsDeflated), this.__generatedMappings = b, s(C, r.compareByOriginalPositions), this.__originalMappings = C;
      }, c.prototype._findMapping = function (e, n, t, r, i, a) {
        if (e[t] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + e[t]);
        if (e[r] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + e[r]);
        return o.search(e, n, i, a);
      }, c.prototype.computeColumnSpans = function () {
        for (var e = 0; e < this._generatedMappings.length; ++e) {
          var n = this._generatedMappings[e];

          if (e + 1 < this._generatedMappings.length) {
            var t = this._generatedMappings[e + 1];

            if (n.generatedLine === t.generatedLine) {
              n.lastGeneratedColumn = t.generatedColumn - 1;
              continue;
            }
          }

          n.lastGeneratedColumn = 1 / 0;
        }
      }, c.prototype.originalPositionFor = function (e) {
        var n = {
          generatedLine: r.getArg(e, "line"),
          generatedColumn: r.getArg(e, "column")
        },
            t = this._findMapping(n, this._generatedMappings, "generatedLine", "generatedColumn", r.compareByGeneratedPositionsDeflated, r.getArg(e, "bias", u.GREATEST_LOWER_BOUND));

        if (t >= 0) {
          var o = this._generatedMappings[t];

          if (o.generatedLine === n.generatedLine) {
            var i = r.getArg(o, "source", null);
            null !== i && (i = this._sources.at(i), null != this.sourceRoot && (i = r.join(this.sourceRoot, i)));
            var a = r.getArg(o, "name", null);
            return null !== a && (a = this._names.at(a)), {
              source: i,
              line: r.getArg(o, "originalLine", null),
              column: r.getArg(o, "originalColumn", null),
              name: a
            };
          }
        }

        return {
          source: null,
          line: null,
          column: null,
          name: null
        };
      }, c.prototype.hasContentsOfAllSources = function () {
        return !!this.sourcesContent && this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function (e) {
          return null == e;
        });
      }, c.prototype.sourceContentFor = function (e, n) {
        if (!this.sourcesContent) return null;
        if (null != this.sourceRoot && (e = r.relative(this.sourceRoot, e)), this._sources.has(e)) return this.sourcesContent[this._sources.indexOf(e)];
        var t;

        if (null != this.sourceRoot && (t = r.urlParse(this.sourceRoot))) {
          var o = e.replace(/^file:\/\//, "");
          if ("file" == t.scheme && this._sources.has(o)) return this.sourcesContent[this._sources.indexOf(o)];
          if ((!t.path || "/" == t.path) && this._sources.has("/" + e)) return this.sourcesContent[this._sources.indexOf("/" + e)];
        }

        if (n) return null;
        throw new Error('"' + e + '" is not in the SourceMap.');
      }, c.prototype.generatedPositionFor = function (e) {
        var n = r.getArg(e, "source");
        if (null != this.sourceRoot && (n = r.relative(this.sourceRoot, n)), !this._sources.has(n)) return {
          line: null,
          column: null,
          lastColumn: null
        };

        var t = {
          source: n = this._sources.indexOf(n),
          originalLine: r.getArg(e, "line"),
          originalColumn: r.getArg(e, "column")
        },
            o = this._findMapping(t, this._originalMappings, "originalLine", "originalColumn", r.compareByOriginalPositions, r.getArg(e, "bias", u.GREATEST_LOWER_BOUND));

        if (o >= 0) {
          var i = this._originalMappings[o];
          if (i.source === t.source) return {
            line: r.getArg(i, "generatedLine", null),
            column: r.getArg(i, "generatedColumn", null),
            lastColumn: r.getArg(i, "lastGeneratedColumn", null)
          };
        }

        return {
          line: null,
          column: null,
          lastColumn: null
        };
      }, f.prototype = Object.create(u.prototype), f.prototype.constructor = u, f.prototype._version = 3, Object.defineProperty(f.prototype, "sources", {
        get: function get() {
          for (var e = [], n = 0; n < this._sections.length; n++) {
            for (var t = 0; t < this._sections[n].consumer.sources.length; t++) {
              e.push(this._sections[n].consumer.sources[t]);
            }
          }

          return e;
        }
      }), f.prototype.originalPositionFor = function (e) {
        var n = {
          generatedLine: r.getArg(e, "line"),
          generatedColumn: r.getArg(e, "column")
        },
            t = o.search(n, this._sections, function (e, n) {
          return e.generatedLine - n.generatedOffset.generatedLine || e.generatedColumn - n.generatedOffset.generatedColumn;
        }),
            i = this._sections[t];
        return i ? i.consumer.originalPositionFor({
          line: n.generatedLine - (i.generatedOffset.generatedLine - 1),
          column: n.generatedColumn - (i.generatedOffset.generatedLine === n.generatedLine ? i.generatedOffset.generatedColumn - 1 : 0),
          bias: e.bias
        }) : {
          source: null,
          line: null,
          column: null,
          name: null
        };
      }, f.prototype.hasContentsOfAllSources = function () {
        return this._sections.every(function (e) {
          return e.consumer.hasContentsOfAllSources();
        });
      }, f.prototype.sourceContentFor = function (e, n) {
        for (var t = 0; t < this._sections.length; t++) {
          var r = this._sections[t].consumer.sourceContentFor(e, !0);

          if (r) return r;
        }

        if (n) return null;
        throw new Error('"' + e + '" is not in the SourceMap.');
      }, f.prototype.generatedPositionFor = function (e) {
        for (var n = 0; n < this._sections.length; n++) {
          var t = this._sections[n];

          if (-1 !== t.consumer.sources.indexOf(r.getArg(e, "source"))) {
            var o = t.consumer.generatedPositionFor(e);
            if (o) return {
              line: o.line + (t.generatedOffset.generatedLine - 1),
              column: o.column + (t.generatedOffset.generatedLine === o.line ? t.generatedOffset.generatedColumn - 1 : 0)
            };
          }
        }

        return {
          line: null,
          column: null
        };
      }, f.prototype._parseMappings = function (e, n) {
        this.__generatedMappings = [], this.__originalMappings = [];

        for (var t = 0; t < this._sections.length; t++) {
          for (var o = this._sections[t], i = o.consumer._generatedMappings, a = 0; a < i.length; a++) {
            var u = i[a],
                c = o.consumer._sources.at(u.source);

            null !== o.consumer.sourceRoot && (c = r.join(o.consumer.sourceRoot, c)), this._sources.add(c), c = this._sources.indexOf(c);

            var l = o.consumer._names.at(u.name);

            this._names.add(l), l = this._names.indexOf(l);
            var f = {
              source: c,
              generatedLine: u.generatedLine + (o.generatedOffset.generatedLine - 1),
              generatedColumn: u.generatedColumn + (o.generatedOffset.generatedLine === u.generatedLine ? o.generatedOffset.generatedColumn - 1 : 0),
              originalLine: u.originalLine,
              originalColumn: u.originalColumn,
              name: l
            };
            this.__generatedMappings.push(f), "number" == typeof f.originalLine && this.__originalMappings.push(f);
          }
        }

        s(this.__generatedMappings, r.compareByGeneratedPositionsDeflated), s(this.__originalMappings, r.compareByOriginalPositions);
      };
    },
    902: function _(e, n, t) {
      var r = t(647),
          o = t(479),
          i = t(817).I,
          a = t(27).H;

      function s(e) {
        e || (e = {}), this._file = o.getArg(e, "file", null), this._sourceRoot = o.getArg(e, "sourceRoot", null), this._skipValidation = o.getArg(e, "skipValidation", !1), this._sources = new i(), this._names = new i(), this._mappings = new a(), this._sourcesContents = null;
      }

      s.prototype._version = 3, s.fromSourceMap = function (e) {
        var n = e.sourceRoot,
            t = new s({
          file: e.file,
          sourceRoot: n
        });
        return e.eachMapping(function (e) {
          var r = {
            generated: {
              line: e.generatedLine,
              column: e.generatedColumn
            }
          };
          null != e.source && (r.source = e.source, null != n && (r.source = o.relative(n, r.source)), r.original = {
            line: e.originalLine,
            column: e.originalColumn
          }, null != e.name && (r.name = e.name)), t.addMapping(r);
        }), e.sources.forEach(function (n) {
          var r = e.sourceContentFor(n);
          null != r && t.setSourceContent(n, r);
        }), t;
      }, s.prototype.addMapping = function (e) {
        var n = o.getArg(e, "generated"),
            t = o.getArg(e, "original", null),
            r = o.getArg(e, "source", null),
            i = o.getArg(e, "name", null);
        this._skipValidation || this._validateMapping(n, t, r, i), null != r && (r = String(r), this._sources.has(r) || this._sources.add(r)), null != i && (i = String(i), this._names.has(i) || this._names.add(i)), this._mappings.add({
          generatedLine: n.line,
          generatedColumn: n.column,
          originalLine: null != t && t.line,
          originalColumn: null != t && t.column,
          source: r,
          name: i
        });
      }, s.prototype.setSourceContent = function (e, n) {
        var t = e;
        null != this._sourceRoot && (t = o.relative(this._sourceRoot, t)), null != n ? (this._sourcesContents || (this._sourcesContents = Object.create(null)), this._sourcesContents[o.toSetString(t)] = n) : this._sourcesContents && (delete this._sourcesContents[o.toSetString(t)], 0 === Object.keys(this._sourcesContents).length && (this._sourcesContents = null));
      }, s.prototype.applySourceMap = function (e, n, t) {
        var r = n;

        if (null == n) {
          if (null == e.file) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
          r = e.file;
        }

        var a = this._sourceRoot;
        null != a && (r = o.relative(a, r));
        var s = new i(),
            u = new i();
        this._mappings.unsortedForEach(function (n) {
          if (n.source === r && null != n.originalLine) {
            var i = e.originalPositionFor({
              line: n.originalLine,
              column: n.originalColumn
            });
            null != i.source && (n.source = i.source, null != t && (n.source = o.join(t, n.source)), null != a && (n.source = o.relative(a, n.source)), n.originalLine = i.line, n.originalColumn = i.column, null != i.name && (n.name = i.name));
          }

          var c = n.source;
          null == c || s.has(c) || s.add(c);
          var l = n.name;
          null == l || u.has(l) || u.add(l);
        }, this), this._sources = s, this._names = u, e.sources.forEach(function (n) {
          var r = e.sourceContentFor(n);
          null != r && (null != t && (n = o.join(t, n)), null != a && (n = o.relative(a, n)), this.setSourceContent(n, r));
        }, this);
      }, s.prototype._validateMapping = function (e, n, t, r) {
        if ((!(e && "line" in e && "column" in e && e.line > 0 && e.column >= 0) || n || t || r) && !(e && "line" in e && "column" in e && n && "line" in n && "column" in n && e.line > 0 && e.column >= 0 && n.line > 0 && n.column >= 0 && t)) throw new Error("Invalid mapping: " + JSON.stringify({
          generated: e,
          source: t,
          original: n,
          name: r
        }));
      }, s.prototype._serializeMappings = function () {
        for (var e, n, t, i, a = 0, s = 1, u = 0, c = 0, l = 0, f = 0, p = "", h = this._mappings.toArray(), g = 0, d = h.length; g < d; g++) {
          if (e = "", (n = h[g]).generatedLine !== s) for (a = 0; n.generatedLine !== s;) {
            e += ";", s++;
          } else if (g > 0) {
            if (!o.compareByGeneratedPositionsInflated(n, h[g - 1])) continue;
            e += ",";
          }
          e += r.encode(n.generatedColumn - a), a = n.generatedColumn, null != n.source && (i = this._sources.indexOf(n.source), e += r.encode(i - f), f = i, e += r.encode(n.originalLine - 1 - c), c = n.originalLine - 1, e += r.encode(n.originalColumn - u), u = n.originalColumn, null != n.name && (t = this._names.indexOf(n.name), e += r.encode(t - l), l = t)), p += e;
        }

        return p;
      }, s.prototype._generateSourcesContent = function (e, n) {
        return e.map(function (e) {
          if (!this._sourcesContents) return null;
          null != n && (e = o.relative(n, e));
          var t = o.toSetString(e);
          return Object.prototype.hasOwnProperty.call(this._sourcesContents, t) ? this._sourcesContents[t] : null;
        }, this);
      }, s.prototype.toJSON = function () {
        var e = {
          version: this._version,
          sources: this._sources.toArray(),
          names: this._names.toArray(),
          mappings: this._serializeMappings()
        };
        return null != this._file && (e.file = this._file), null != this._sourceRoot && (e.sourceRoot = this._sourceRoot), this._sourcesContents && (e.sourcesContent = this._generateSourcesContent(e.sources, e.sourceRoot)), e;
      }, s.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
      }, n.SourceMapGenerator = s;
    },
    786: function _(e, n, t) {
      var r = t(902).SourceMapGenerator,
          o = t(479),
          i = /(\r?\n)/,
          a = "$$$isSourceNode$$$";

      function s(e, n, t, r, o) {
        this.children = [], this.sourceContents = {}, this.line = null == e ? null : e, this.column = null == n ? null : n, this.source = null == t ? null : t, this.name = null == o ? null : o, this[a] = !0, null != r && this.add(r);
      }

      s.fromStringWithSourceMap = function (e, n, t) {
        var r = new s(),
            a = e.split(i),
            u = function u() {
          return a.shift() + (a.shift() || "");
        },
            c = 1,
            l = 0,
            f = null;

        return n.eachMapping(function (e) {
          if (null !== f) {
            if (!(c < e.generatedLine)) {
              var n = (t = a[0]).substr(0, e.generatedColumn - l);
              return a[0] = t.substr(e.generatedColumn - l), l = e.generatedColumn, p(f, n), void (f = e);
            }

            p(f, u()), c++, l = 0;
          }

          for (; c < e.generatedLine;) {
            r.add(u()), c++;
          }

          if (l < e.generatedColumn) {
            var t = a[0];
            r.add(t.substr(0, e.generatedColumn)), a[0] = t.substr(e.generatedColumn), l = e.generatedColumn;
          }

          f = e;
        }, this), a.length > 0 && (f && p(f, u()), r.add(a.join(""))), n.sources.forEach(function (e) {
          var i = n.sourceContentFor(e);
          null != i && (null != t && (e = o.join(t, e)), r.setSourceContent(e, i));
        }), r;

        function p(e, n) {
          if (null === e || void 0 === e.source) r.add(n);else {
            var i = t ? o.join(t, e.source) : e.source;
            r.add(new s(e.originalLine, e.originalColumn, i, n, e.name));
          }
        }
      }, s.prototype.add = function (e) {
        if (Array.isArray(e)) e.forEach(function (e) {
          this.add(e);
        }, this);else {
          if (!e[a] && "string" != typeof e) throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + e);
          e && this.children.push(e);
        }
        return this;
      }, s.prototype.prepend = function (e) {
        if (Array.isArray(e)) for (var n = e.length - 1; n >= 0; n--) {
          this.prepend(e[n]);
        } else {
          if (!e[a] && "string" != typeof e) throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + e);
          this.children.unshift(e);
        }
        return this;
      }, s.prototype.walk = function (e) {
        for (var n, t = 0, r = this.children.length; t < r; t++) {
          (n = this.children[t])[a] ? n.walk(e) : "" !== n && e(n, {
            source: this.source,
            line: this.line,
            column: this.column,
            name: this.name
          });
        }
      }, s.prototype.join = function (e) {
        var n,
            t,
            r = this.children.length;

        if (r > 0) {
          for (n = [], t = 0; t < r - 1; t++) {
            n.push(this.children[t]), n.push(e);
          }

          n.push(this.children[t]), this.children = n;
        }

        return this;
      }, s.prototype.replaceRight = function (e, n) {
        var t = this.children[this.children.length - 1];
        return t[a] ? t.replaceRight(e, n) : "string" == typeof t ? this.children[this.children.length - 1] = t.replace(e, n) : this.children.push("".replace(e, n)), this;
      }, s.prototype.setSourceContent = function (e, n) {
        this.sourceContents[o.toSetString(e)] = n;
      }, s.prototype.walkSourceContents = function (e) {
        for (var n = 0, t = this.children.length; n < t; n++) {
          this.children[n][a] && this.children[n].walkSourceContents(e);
        }

        var r = Object.keys(this.sourceContents);

        for (n = 0, t = r.length; n < t; n++) {
          e(o.fromSetString(r[n]), this.sourceContents[r[n]]);
        }
      }, s.prototype.toString = function () {
        var e = "";
        return this.walk(function (n) {
          e += n;
        }), e;
      }, s.prototype.toStringWithSourceMap = function (e) {
        var n = {
          code: "",
          line: 1,
          column: 0
        },
            t = new r(e),
            o = !1,
            i = null,
            a = null,
            s = null,
            u = null;
        return this.walk(function (e, r) {
          n.code += e, null !== r.source && null !== r.line && null !== r.column ? (i === r.source && a === r.line && s === r.column && u === r.name || t.addMapping({
            source: r.source,
            original: {
              line: r.line,
              column: r.column
            },
            generated: {
              line: n.line,
              column: n.column
            },
            name: r.name
          }), i = r.source, a = r.line, s = r.column, u = r.name, o = !0) : o && (t.addMapping({
            generated: {
              line: n.line,
              column: n.column
            }
          }), i = null, o = !1);

          for (var c = 0, l = e.length; c < l; c++) {
            10 === e.charCodeAt(c) ? (n.line++, n.column = 0, c + 1 === l ? (i = null, o = !1) : o && t.addMapping({
              source: r.source,
              original: {
                line: r.line,
                column: r.column
              },
              generated: {
                line: n.line,
                column: n.column
              },
              name: r.name
            })) : n.column++;
          }
        }), this.walkSourceContents(function (e, n) {
          t.setSourceContent(e, n);
        }), {
          code: n.code,
          map: t
        };
      }, n.SourceNode = s;
    },
    479: function _(e, n) {
      n.getArg = function (e, n, t) {
        if (n in e) return e[n];
        if (3 === arguments.length) return t;
        throw new Error('"' + n + '" is a required argument.');
      };

      var t = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/,
          r = /^data:.+\,.+$/;

      function o(e) {
        var n = e.match(t);
        return n ? {
          scheme: n[1],
          auth: n[2],
          host: n[3],
          port: n[4],
          path: n[5]
        } : null;
      }

      function i(e) {
        var n = "";
        return e.scheme && (n += e.scheme + ":"), n += "//", e.auth && (n += e.auth + "@"), e.host && (n += e.host), e.port && (n += ":" + e.port), e.path && (n += e.path), n;
      }

      function a(e) {
        var t = e,
            r = o(e);

        if (r) {
          if (!r.path) return e;
          t = r.path;
        }

        for (var a, s = n.isAbsolute(t), u = t.split(/\/+/), c = 0, l = u.length - 1; l >= 0; l--) {
          "." === (a = u[l]) ? u.splice(l, 1) : ".." === a ? c++ : c > 0 && ("" === a ? (u.splice(l + 1, c), c = 0) : (u.splice(l, 2), c--));
        }

        return "" === (t = u.join("/")) && (t = s ? "/" : "."), r ? (r.path = t, i(r)) : t;
      }

      n.urlParse = o, n.urlGenerate = i, n.normalize = a, n.join = function (e, n) {
        "" === e && (e = "."), "" === n && (n = ".");
        var t = o(n),
            s = o(e);
        if (s && (e = s.path || "/"), t && !t.scheme) return s && (t.scheme = s.scheme), i(t);
        if (t || n.match(r)) return n;
        if (s && !s.host && !s.path) return s.host = n, i(s);
        var u = "/" === n.charAt(0) ? n : a(e.replace(/\/+$/, "") + "/" + n);
        return s ? (s.path = u, i(s)) : u;
      }, n.isAbsolute = function (e) {
        return "/" === e.charAt(0) || !!e.match(t);
      }, n.relative = function (e, n) {
        "" === e && (e = "."), e = e.replace(/\/$/, "");

        for (var t = 0; 0 !== n.indexOf(e + "/");) {
          var r = e.lastIndexOf("/");
          if (r < 0) return n;
          if ((e = e.slice(0, r)).match(/^([^\/]+:\/)?\/*$/)) return n;
          ++t;
        }

        return Array(t + 1).join("../") + n.substr(e.length + 1);
      };
      var s = !("__proto__" in Object.create(null));

      function u(e) {
        return e;
      }

      function c(e) {
        if (!e) return !1;
        var n = e.length;
        if (n < 9) return !1;
        if (95 !== e.charCodeAt(n - 1) || 95 !== e.charCodeAt(n - 2) || 111 !== e.charCodeAt(n - 3) || 116 !== e.charCodeAt(n - 4) || 111 !== e.charCodeAt(n - 5) || 114 !== e.charCodeAt(n - 6) || 112 !== e.charCodeAt(n - 7) || 95 !== e.charCodeAt(n - 8) || 95 !== e.charCodeAt(n - 9)) return !1;

        for (var t = n - 10; t >= 0; t--) {
          if (36 !== e.charCodeAt(t)) return !1;
        }

        return !0;
      }

      function l(e, n) {
        return e === n ? 0 : e > n ? 1 : -1;
      }

      n.toSetString = s ? u : function (e) {
        return c(e) ? "$" + e : e;
      }, n.fromSetString = s ? u : function (e) {
        return c(e) ? e.slice(1) : e;
      }, n.compareByOriginalPositions = function (e, n, t) {
        var r = e.source - n.source;
        return 0 !== r || 0 != (r = e.originalLine - n.originalLine) || 0 != (r = e.originalColumn - n.originalColumn) || t || 0 != (r = e.generatedColumn - n.generatedColumn) || 0 != (r = e.generatedLine - n.generatedLine) ? r : e.name - n.name;
      }, n.compareByGeneratedPositionsDeflated = function (e, n, t) {
        var r = e.generatedLine - n.generatedLine;
        return 0 !== r || 0 != (r = e.generatedColumn - n.generatedColumn) || t || 0 != (r = e.source - n.source) || 0 != (r = e.originalLine - n.originalLine) || 0 != (r = e.originalColumn - n.originalColumn) ? r : e.name - n.name;
      }, n.compareByGeneratedPositionsInflated = function (e, n) {
        var t = e.generatedLine - n.generatedLine;
        return 0 !== t || 0 != (t = e.generatedColumn - n.generatedColumn) || 0 !== (t = l(e.source, n.source)) || 0 != (t = e.originalLine - n.originalLine) || 0 != (t = e.originalColumn - n.originalColumn) ? t : l(e.name, n.name);
      };
    },
    252: function _(e, n, t) {
      n.SourceMapGenerator = t(902).SourceMapGenerator, n.SourceMapConsumer = t(667).SourceMapConsumer, n.SourceNode = t(786).SourceNode;
    },
    358: function _(e, n, t) {
      var r, o, i;
      !function (a, s) {
        "use strict";

        o = [t(252), t(829)], void 0 === (i = "function" == typeof (r = function r(e, n) {
          function t(e) {
            return new Promise(function (n, t) {
              var r = new XMLHttpRequest();
              r.open("get", e), r.onerror = t, r.onreadystatechange = function () {
                4 === r.readyState && (r.status >= 200 && r.status < 300 || "file://" === e.substr(0, 7) && r.responseText ? n(r.responseText) : t(new Error("HTTP status: " + r.status + " retrieving " + e)));
              }, r.send();
            });
          }

          function r(e) {
            if ("undefined" != typeof window && window.atob) return window.atob(e);
            throw new Error("You must supply a polyfill for window.atob in this environment");
          }

          function o(e) {
            if ("object" != typeof e) throw new TypeError("Given StackFrame is not an object");
            if ("string" != typeof e.fileName) throw new TypeError("Given file name is not a String");
            if ("number" != typeof e.lineNumber || e.lineNumber % 1 != 0 || e.lineNumber < 1) throw new TypeError("Given line number must be a positive integer");
            if ("number" != typeof e.columnNumber || e.columnNumber % 1 != 0 || e.columnNumber < 0) throw new TypeError("Given column number must be a non-negative integer");
            return !0;
          }

          return function i(a) {
            if (!(this instanceof i)) return new i(a);
            a = a || {}, this.sourceCache = a.sourceCache || {}, this.sourceMapConsumerCache = a.sourceMapConsumerCache || {}, this.ajax = a.ajax || t, this._atob = a.atob || r, this._get = function (e) {
              return new Promise(function (n, t) {
                var r = "data:" === e.substr(0, 5);
                if (this.sourceCache[e]) n(this.sourceCache[e]);else if (a.offline && !r) t(new Error("Cannot make network requests in offline mode"));else if (r) {
                  var o = e.match(/^data:application\/json;([\w=:"-]+;)*base64,/);

                  if (o) {
                    var i = o[0].length,
                        s = e.substr(i),
                        u = this._atob(s);

                    this.sourceCache[e] = u, n(u);
                  } else t(new Error("The encoding of the inline sourcemap is not supported"));
                } else {
                  var c = this.ajax(e, {
                    method: "get"
                  });
                  this.sourceCache[e] = c, c.then(n, t);
                }
              }.bind(this));
            }, this._getSourceMapConsumer = function (n, t) {
              return new Promise(function (r) {
                if (this.sourceMapConsumerCache[n]) r(this.sourceMapConsumerCache[n]);else {
                  var o = new Promise(function (r, o) {
                    return this._get(n).then(function (n) {
                      "string" == typeof n && (n = function (e) {
                        if ("undefined" != typeof JSON && JSON.parse) return JSON.parse(e);
                        throw new Error("You must supply a polyfill for JSON.parse in this environment");
                      }(n.replace(/^\)\]\}'/, ""))), void 0 === n.sourceRoot && (n.sourceRoot = t), r(new e.SourceMapConsumer(n));
                    }, o);
                  }.bind(this));
                  this.sourceMapConsumerCache[n] = o, r(o);
                }
              }.bind(this));
            }, this.pinpoint = function (e) {
              return new Promise(function (n, t) {
                this.getMappedLocation(e).then(function (e) {
                  function t() {
                    n(e);
                  }

                  this.findFunctionName(e).then(n, t).catch(t);
                }.bind(this), t);
              }.bind(this));
            }, this.findFunctionName = function (e) {
              return new Promise(function (t, r) {
                o(e), this._get(e.fileName).then(function (r) {
                  var o = e.lineNumber,
                      i = e.columnNumber,
                      a = function (e, n) {
                    for (var t = [/['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/, /function\s+([^('"`]*?)\s*\(([^)]*)\)/, /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/, /\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/, /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/], r = e.split("\n"), o = "", i = Math.min(n, 20), a = 0; a < i; ++a) {
                      var s = r[n - a - 1],
                          u = s.indexOf("//");

                      if (u >= 0 && (s = s.substr(0, u)), s) {
                        o = s + o;

                        for (var c = t.length, l = 0; l < c; l++) {
                          var f = t[l].exec(o);
                          if (f && f[1]) return f[1];
                        }
                      }
                    }
                  }(r, o);

                  t(a ? new n({
                    functionName: a,
                    args: e.args,
                    fileName: e.fileName,
                    lineNumber: o,
                    columnNumber: i
                  }) : e);
                }, r).catch(r);
              }.bind(this));
            }, this.getMappedLocation = function (e) {
              return new Promise(function (t, r) {
                (function () {
                  if ("function" != typeof Object.defineProperty || "function" != typeof Object.create) throw new Error("Unable to consume source maps in older browsers");
                })(), o(e);
                var i = this.sourceCache,
                    a = e.fileName;

                this._get(a).then(function (r) {
                  var o = function (e) {
                    for (var n, t, r = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm; t = r.exec(e);) {
                      n = t[1];
                    }

                    if (n) return n;
                    throw new Error("sourceMappingURL not found");
                  }(r),
                      s = "data:" === o.substr(0, 5),
                      u = a.substring(0, a.lastIndexOf("/") + 1);

                  return "/" === o[0] || s || /^https?:\/\/|^\/\//i.test(o) || (o = u + o), this._getSourceMapConsumer(o, u).then(function (r) {
                    return function (e, t, r) {
                      return new Promise(function (o, i) {
                        var a = t.originalPositionFor({
                          line: e.lineNumber,
                          column: e.columnNumber
                        });

                        if (a.source) {
                          var s = t.sourceContentFor(a.source);
                          s && (r[a.source] = s), o(new n({
                            functionName: a.name || e.functionName,
                            args: e.args,
                            fileName: a.source,
                            lineNumber: a.line,
                            columnNumber: a.column
                          }));
                        } else i(new Error("Could not get original source for given stackframe and source map"));
                      });
                    }(e, r, i).then(t).catch(function () {
                      t(e);
                    });
                  });
                }.bind(this), r).catch(r);
              }.bind(this));
            };
          };
        }) ? r.apply(n, o) : r) || (e.exports = i);
      }();
    },
    401: function _(e, n, t) {
      var r, o, i;
      !function (a, s) {
        "use strict";

        o = [t(180), t(595), t(358)], r = function r(e, n, t) {
          var r = {
            filter: function filter(e) {
              return -1 === (e.functionName || "").indexOf("StackTrace$$") && -1 === (e.functionName || "").indexOf("ErrorStackParser$$") && -1 === (e.functionName || "").indexOf("StackTraceGPS$$") && -1 === (e.functionName || "").indexOf("StackGenerator$$");
            },
            sourceCache: {}
          },
              o = function o() {
            try {
              throw new Error();
            } catch (e) {
              return e;
            }
          };

          function i(e, n) {
            var t = {};
            return [e, n].forEach(function (e) {
              for (var n in e) {
                Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
              }

              return t;
            }), t;
          }

          function a(e) {
            return e.stack || e["opera#sourceloc"];
          }

          function s(e, n) {
            return "function" == typeof n ? e.filter(n) : e;
          }

          return {
            get: function get(e) {
              var n = o();
              return a(n) ? this.fromError(n, e) : this.generateArtificially(e);
            },
            getSync: function getSync(t) {
              t = i(r, t);
              var u = o();
              return s(a(u) ? e.parse(u) : n.backtrace(t), t.filter);
            },
            fromError: function fromError(n, o) {
              o = i(r, o);
              var a = new t(o);
              return new Promise(function (t) {
                var r = s(e.parse(n), o.filter);
                t(Promise.all(r.map(function (e) {
                  return new Promise(function (n) {
                    function t() {
                      n(e);
                    }

                    a.pinpoint(e).then(n, t).catch(t);
                  });
                })));
              }.bind(this));
            },
            generateArtificially: function generateArtificially(e) {
              e = i(r, e);
              var t = n.backtrace(e);
              return "function" == typeof e.filter && (t = t.filter(e.filter)), Promise.resolve(t);
            },
            instrument: function instrument(e, n, t, r) {
              if ("function" != typeof e) throw new Error("Cannot instrument non-function object");
              if ("function" == typeof e.__stacktraceOriginalFn) return e;

              var o = function () {
                try {
                  return this.get().then(n, t).catch(t), e.apply(r || this, arguments);
                } catch (e) {
                  throw a(e) && this.fromError(e).then(n, t).catch(t), e;
                }
              }.bind(this);

              return o.__stacktraceOriginalFn = e, o;
            },
            deinstrument: function deinstrument(e) {
              if ("function" != typeof e) throw new Error("Cannot de-instrument non-function object");
              return "function" == typeof e.__stacktraceOriginalFn ? e.__stacktraceOriginalFn : e;
            },
            report: function report(e, n, t, r) {
              return new Promise(function (o, i) {
                var a = new XMLHttpRequest();

                if (a.onerror = i, a.onreadystatechange = function () {
                  4 === a.readyState && (a.status >= 200 && a.status < 400 ? o(a.responseText) : i(new Error("POST to " + n + " failed with status: " + a.status)));
                }, a.open("post", n), a.setRequestHeader("Content-Type", "application/json"), r && "object" == typeof r.headers) {
                  var s = r.headers;

                  for (var u in s) {
                    Object.prototype.hasOwnProperty.call(s, u) && a.setRequestHeader(u, s[u]);
                  }
                }

                var c = {
                  stack: e
                };
                null != t && (c.message = t), a.send(JSON.stringify(c));
              });
            }
          };
        }, void 0 === (i = r.apply(n, o)) || (e.exports = i);
      }();
    },
    607: function _(e, n, t) {
      "use strict";

      var r = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      if (Object.defineProperty(n, "__esModule", {
        value: !0
      }), window && !window.Promise) throw new Error("Not compatible browser detected, Muscula logging will not be started. Please use v1. script for support");
      var o,
          i = r(t(401));
      window.Muscula = window.Muscula || {};

      var a = {
        logId: "",
        harvesterUrl: "https://harvester.muscula.com"
      },
          s = function () {
        function e() {}

        return e.Init = function (e, n) {
          a.logId = e, n && (a.harvesterUrl = n), "undefined" != typeof window && this.BindOnError();
        }, e.OnError = function (n, t, r, o, a) {
          try {
            "object" == typeof n && n.srcElement && n.target && "[object HTMLScriptElement]" === n.srcElement && "[object HTMLScriptElement]" === n.target ? n = "Error loading script" : n && n.srcElement ? n = "Error in event srcElement: " + n.srcElement + ", target:" + n.target : n && n.toString && (n = n.toString()), a && i.default.fromError(a).then(function (i) {
              e.Send(1, n + "", {}, a, i, t, r, o);
            }).catch(function () {
              e.Send(1, n + "", {}, a, void 0, t, r, o);
            });
          } catch (n) {
            e.Error("Muscula Error when handling onError", n);
          }

          return "function" == typeof window.Muscula.onerrorOriginalHandler && window.Muscula.onerrorOriginalHandler(n, t, r, o, a), !1;
        }, e.BindOnError = function () {
          if (window.onerror = e.OnError, Array.isArray(window.Muscula.errors)) for (var n = 0, t = window.Muscula.errors; n < t.length; n++) {
            var r = t[n];
            e.OnError.apply(e, r);
          }
        }, e.ErrorWithStackTrace = function (e, n, t, r) {
          var o = this;
          if ("object" == typeof t) i.default.fromError(t).then(function (i) {
            o.Send(e, n, r, t, i);
          }).catch(function () {
            o.Send(e, n, r, t);
          });else try {
            i.default.generateArtificially().then(function (t) {
              o.Send(e, n, r, void 0, t);
            }).catch(function () {
              o.Send(e, n, r, void 0, void 0);
            });
          } catch (e) {
            console.error("Error when generating artificially stacktrace");
          }
        }, e.Send = function (e, n, t, r, i, s, u, c) {
          try {
            if (!a.logId) return void console.error("Muscula Log Id must be provided");
            var l = void 0;

            if (i && (l = i.map(function (e) {
              return e.functionName + "@" + e.fileName + ":" + e.lineNumber + ":" + e.columnNumber;
            }), !s || !u)) {
              var f = i.pop();
              f && (u = f.lineNumber, s = f.fileName, c = f.columnNumber);
            }

            var p = {
              logId: a.logId,
              severity: e,
              message: n,
              pageUrl: void 0 !== window.document ? window.document.location.href : void 0,
              jsUrl: s,
              lineNumber: u,
              column: c,
              printStack: l,
              userAgent: navigator.userAgent,
              exception: r
            };
            null != t && Object.keys(t) && (p.structuralData = t);
            var h = JSON.stringify(p);
            if (o) return console.info(p), void (o.innerHTML = h);
            var g = new XMLHttpRequest();
            if ("withCredentials" in g || "ReactNative" === navigator.product) return g.open("POST", a.harvesterUrl + "/js"), g.setRequestHeader("Content-Type", "application/json"), void g.send(h);
            var d = document.createElement("iframe"),
                m = "UNIQUE_" + new Date().getTime() + Math.random();
            document.body.appendChild(d), d.style.display = "none", d.contentWindow && (d.contentWindow.name = m);
            var v = document.createElement("form");
            v.target = m, v.action = a.harvesterUrl + "/jsform", v.method = "POST";

            var _ = document.createElement("input");

            _.type = "hidden", _.name = "message", _.value = h, v.appendChild(_), document.body.appendChild(v), v.submit();
          } catch (e) {
            console.log("Muscula: Error on send", e);
          }
        }, e.SetDevelopmentMode = function () {
          "undefined" != typeof window && (window.document.body.innerHTML += '<div id="musculaDevelopmentInfo"></div>', o = window.document.querySelector("#musculaDevelopmentInfo"));
        }, e.Fatal = function (e, n, t) {
          this.ErrorWithStackTrace(0, e, n, t);
        }, e.Error = function (e, n, t) {
          this.ErrorWithStackTrace(1, e, n, t);
        }, e.Info = function (e, n) {
          this.Send(3, e, n);
        }, e.Warning = function (e, n) {
          this.Send(2, e, n);
        }, e.Debug = function (e, n) {
          this.Send(4, e, n);
        }, e.Trace = function (e, n) {
          this.Send(5, e, n);
        }, e;
      }();

      n.default = s, window.Muscula.logId && (window.MusculaLog = s, window.MusculaLog.Init(window.Muscula.logId, window.Muscula.harvesterUrl));
    }
  }, n = {}, function t(r) {
    var o = n[r];
    if (void 0 !== o) return o.exports;
    var i = n[r] = {
      exports: {}
    };
    return e[r].call(i.exports, i, i.exports, t), i.exports;
  }(607).default;
  var e, n;
});